import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import { injectConfig, configShape } from '@client/hoc/config';
import { gridConfig } from '../../../config';
import {
    TWENTY_FOUR_HOURS_IN_MILLISECONDS
} from '../../../config/constants';

import OpenCampaign from './OpenCampaign';
import UpcomingCampaign from './UpcomingCampaign';

const DEFAULT_STYLES = {
    visibility: 'visible',
    backgroundImage: ''
};

export class Campaign extends PureComponent {
    render() {
        const {
            campaign,
            isUpcoming,
            dimension,
            campaignStyles,
            columnCount,
            showDelivery,
            showPopover,
            closePopover,
            position,
            config,
        } = this.props;

        const campaignStyle = {
            ...DEFAULT_STYLES,
            backgroundImage: `url(${config.getUrl('campaign', campaign.hasLogo)}${this.getImageByBlock(dimension, false)})`,
            left: `${campaignStyles.left}%`,
            paddingTop: `${campaignStyles.paddingTop}%`,
            width: `${campaignStyles.width}%`,
            marginTop: `${campaignStyles.marginTop}%`
        };
        const openCampaignPosition = position.replace(',', '|'); // because tracking requirements

        return (
            <div>
                {isUpcoming ?
                    <UpcomingCampaign
                        campaign={campaign}
                        dimension={dimension}
                        campaignStyles={campaignStyle}
                        columnCount={columnCount}
                        showPopover={showPopover}
                        closePopover={closePopover}
                    /> :
                    <OpenCampaign
                        campaign={campaign}
                        dimension={dimension}
                        campaignStyles={campaignStyle}
                        columnCount={columnCount}
                        showDelivery={showDelivery}
                        position={openCampaignPosition}
                    />
                }
            </div>
        );

    }

    // TODO: can be extracted into helper module
    getImageByBlock(blockGridSize, isHDPI = false) {
        const size = gridConfig.open.gridImagesNames[blockGridSize];
        const quality = isHDPI ? 'highres' : 'normal';
        if (!get(this.props.campaign, `images.${size}`)) {
            return null;
        }

        return this.props.campaign.images[size][quality];
    }

    componentDidMount() {
        const campaign = this.props.campaign;
        const specialTimerThreshold = campaign.dateEnd - Date.now() - TWENTY_FOUR_HOURS_IN_MILLISECONDS;

        if (campaign.options && campaign.options.specialTimer && specialTimerThreshold > 0) {
            this.timer = setTimeout(() => {
                this.setState({
                    updateCampaignTimer: true
                });
            }, specialTimerThreshold);
        }
    }

    componentWillUnmount() {
        if (this.timer) {
            clearTimeout(this.timer);
        }
    }
}

Campaign.propTypes = {
    campaign: PropTypes.object.isRequired,
    isUpcoming: PropTypes.bool.isRequired,
    dimension: PropTypes.string.isRequired,
    campaignStyles: PropTypes.object.isRequired,
    columnCount: PropTypes.number,
    showDelivery: PropTypes.bool,
    showPopover: PropTypes.bool,
    closePopover: PropTypes.func,
    position: PropTypes.string.isRequired,
    config: configShape,
};

export default injectConfig(Campaign);
